import { z } from 'zod';

export const requestAccessSchema = z.object({
  email: z
    .string()
    .min(1, 'Informe seu e-mail.')
    .email('E-mail inválido.')
    .max(254, 'E-mail muito longo.'),
});

export type RequestAccessValues = z.infer<typeof requestAccessSchema>;
